import { Skeleton } from '@mui/material';
import { FC } from 'react';

const UploadFileSkeleton: FC = () => {
  return <Skeleton animation="wave" variant="text" />;
};

export default UploadFileSkeleton;
